import { Button, ListViewGroup, ListViewRow, Popover, PopoverTrigger, Stack, Text } from '@ekhodealer/ekho-common/rev';

import ChevronDown12 from '@common/components/icons/ChevronDown12';
import { PricedLineItem } from '@common/components/PricedLineItem';
import { TextCell } from '@common/components/TextCell';

interface PreorderAccessory {
	name: string;
	count: number;
	imgUrl?: string;
	price?: number;
}

interface AccessoriesCellProps {
	accessories: PreorderAccessory[];
}

const PopoverContent = ({ accessories }: { accessories: PreorderAccessory[] }): React.ReactNode => {
	return (
		<Stack itemsSpacing='8'>
			<Text size='footnote' weight='semibold'>
				PG&A
			</Text>
			<ListViewGroup>
				{accessories.map((item, index) => {
					const label = item.count > 1 ? `${item.name} (x${item.count})` : item.name;

					return (
						<ListViewRow
							key={index}
							bottomContent={
								<PricedLineItem imageUrl={item.imgUrl} primaryLabel={label} price={item.price} />
							}
						/>
					);
				})}
			</ListViewGroup>
		</Stack>
	);
};

export const AccessoriesCell = ({ accessories }: AccessoriesCellProps): React.ReactNode => {
	if (accessories.length === 0) {
		return <TextCell value={undefined} />;
	}

	const displayText = accessories.length === 1 ? '1 item' : `${accessories.length} items`;

	return (
		<PopoverTrigger>
			<Button
				className='pga-cell'
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'>
				<TextCell value={displayText} />
			</Button>
			<Popover offset={-12} crossOffset={-4}>
				<PopoverContent accessories={accessories} />
			</Popover>
		</PopoverTrigger>
	);
};
